'use strict';


FileDataUrlCache.SERVICE_NAME = 'fileDataUrlCache';

FileDataUrlCache.$inject = [
  '$cacheFactory',
];

export function FileDataUrlCache(
  $cacheFactory,
) {
  // eject somewhat eagerly so the file data can be released
  return $cacheFactory.get('FileDataUrlCache') || $cacheFactory('FileDataUrlCache', {capacity: 50});
}



// WEBPACK FOOTER //
// ./src/js/files/services/FileDataUrlCache.js